import {$, PageCollection} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'

export default class CargaCollection extends PageCollection<Carga> {
  constructor(
    filter = {},
    endPoint: string | null = null,
    perPage: number | null = 10,
    currentPage: number | null = 0,
  ) {
    super(Carga, filter, perPage, currentPage)
    this.endpoint = endPoint
  }
}
